// Utils
import { isTaskList } from '../../../../common/elements/utils/elementTypeUtils';
import { isSingleEditorTaskList } from '../../../../common/taskLists/taskListContentVersionUtils';
import { getShowTitle } from '../../taskList/taskListSelector';

export default (props, monitor) => {
    const { draggedElements } = monitor.getItem();

    return (
        draggedElements &&
        draggedElements.every(
            (element) => isTaskList(element) && !isSingleEditorTaskList(element) && !getShowTitle(element),
        )
    );
};
